import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FiBell, FiMessageCircle, FiUsers } from 'react-icons/fi';
import Notifications from './Matrimony/Pages/Notifications';
import Chat from './Matrimony/Chating/ChatPage';
import OnlineUsers from './Matrimony/Chating/Active';
import './RightSideTab.css';

const RightSideTab = () => {
  const [activeTab, setActiveTab] = useState(null);
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [onlineUserCount, setOnlineUserCount] = useState(0);
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const userId = storedUser?._id;

  useEffect(() => {
    const markAllNotificationsAsRead = async () => {
      try {
        await axios.put('https://back.varankal.com/notifications/mark-all-read', {}, {
          withCredentials: true
        });
        setNotificationCount(0); // 🔥 Set to 0 immediately
      } catch (err) {
        console.error('Failed to mark notifications as read:', err);
      }
    };

    if (activeTab === 'notification') {
      markAllNotificationsAsRead();
    }
  }, [activeTab]);



  useEffect(() => {
    if (!userId) return;

    const fetchTotalUnread = async () => {
      try {
        const { data } = await axios.get(
          `https://back.varankal.com/chats/unread-total/${userId}`,
          { withCredentials: true }
        );
        setTotalUnreadCount(data.totalUnread);
      } catch (err) {
        console.error("Failed to fetch chat unread count:", err);
      }
    };

    const fetchUnreadNotifications = async () => {
      try {
        const { data } = await axios.get(
          `https://back.varankal.com/notifications/unread-count?userId=${userId}`,
          {
            withCredentials: true,
            headers: {
              'Cache-Control': 'no-cache'
            }
          }
        );
        console.log("Notification count response:", data); // ✅ add this
        setNotificationCount(data.unreadCount);
      } catch (err) {
        console.error("Failed to fetch notification count:", err);
      }
    };

    const fetchOnlineUserCount = async () => {
      try {
        const { data } = await axios.get(`https://back.varankal.com/chats/opposite-online-user-count/${userId}`, {
          withCredentials: true
        });

        setOnlineUserCount(data.onlineCount);
      } catch (err) {
        console.error("Failed to fetch online user count:", err);
      }
    };


    const fetchAllCounts = () => {
      fetchTotalUnread();
      fetchUnreadNotifications();
      fetchOnlineUserCount();
    };

    fetchAllCounts();
    const interval = setInterval(fetchAllCounts, 500);
    return () => clearInterval(interval);
  }, [userId]);

  const renderTab = () => {
    if (activeTab === 'notification') return <div className="tab-inner-wrapper8899"><Notifications /></div>;
    if (activeTab === 'chat') return <div className="tab-inner-wrapper8899"><Chat userId={userId} /></div>;
    if (activeTab === 'activity') return <div className="tab-inner-wrapper8899"><OnlineUsers /></div>;
    return null;
  };

  return (
    <div className="right-tab-container8899">
      {activeTab && (
        <button
          className="tab-btn-icon8899"
          onClick={() => setActiveTab(null)}
          title="Close Tab"
        >
          ❌
        </button>
      )}

      <div className="tab-buttons8899">
        {/* 🔔 Notification Tab */}
        {/* 🔔 Notification Tab */}
        <button
          className={`tab-btn-icon8899 ${activeTab === 'notification' ? 'active8899' : ''}`}
          onClick={() => setActiveTab('notification')}
          title="Notifications"
        >
          <FiBell />
          {notificationCount > 0 && (
            <span className="chat-badge8899">{notificationCount}</span>
          )}
        </button>

        {/* 💬 Chat Tab */}
        <button
          className={`tab-btn-icon8899 ${activeTab === 'chat' ? 'active8899' : ''}`}
          onClick={() => setActiveTab('chat')}
          title="Chat"
        >
          <FiMessageCircle />
          {totalUnreadCount > 0 && (
            <span className="chat-badge8899">{totalUnreadCount}</span>
          )}
        </button>


        {/* 🟢 Online Users Tab */}
        <button
          className={`tab-btn-icon8899 ${activeTab === 'activity' ? 'active8899' : ''}`}
          onClick={() => setActiveTab('activity')}
          title="Online Users"
        >
          <FiUsers />
          {onlineUserCount > 0 && (
            <span className="chat-badge8899">{onlineUserCount}</span>
          )}
        </button>

      </div>

      <div className={`tab-content8899 ${activeTab ? 'show8899' : ''}`}>
        {renderTab()}
      </div>
    </div>
  );
};

export default RightSideTab;
